$(() => {
    // Верстка закоменчена calculator-index(index)
    try {
        //Range sliders
        let amount = 0;

        let firstLine = document.querySelector('#firstWidthSlider');
        document.querySelector('#firstWidth').addEventListener('input', function () {
            if ($(window).width() > 1280) {
                let nVal = parseInt(this.value);
                let curVal = nVal + 2;
                amount += nVal;
                firstLine.style.width = ((100 / 10) * nVal) + "%";
                $('.calc-price-span[data-calc="1"]').text(amount);
                $(`.slider-dot[data-calc="1"]`).removeClass('active');
                for (let i = 1; i < curVal; i++) {
                    let step = 0;
                    $(`.dot-${i}[data-calc="1"]`).addClass('active');
                }
            } else {
                $(this).attr("max", "4");
                let nVal = parseInt(this.value);
                let curVal = nVal + 2;
                amount += nVal;
                firstLine.style.width = ((100 / 10) * nVal) + "%";
                $('.calc-price-span[data-calc="1"]').text(amount);
                $(`.slider-dot[data-calc="1"]`).removeClass('active');
                for (let i = 1; i < curVal; i++) {
                    let step = 0;
                    $(`.dot-${i}[data-calc="1"]`).addClass('active');
                }
            }
        });

        let secondLine = document.querySelector('#secondWidthSlider');
        document.querySelector('#secondWidth').addEventListener('input', function () {
            if ($(window).width() > 1280) {
                let nVal = parseInt(this.value);
                let curVal = nVal + 2;
                amount += nVal;
                secondLine.style.width = ((100 / 10) * nVal) + "%";
                $('.calc-price-span[data-calc="1"]').text(amount);
                $(`.slider-dot[data-calc="2"]`).removeClass('active');
                for (let i = 1; i < curVal; i++) {
                    let step = 0;
                    $(`.dot-${i}[data-calc="2"]`).addClass('active');
                }
            } else {
                $(this).attr("max", "4");
                let nVal = parseInt(this.value);
                let curVal = nVal + 2;
                amount += nVal;
                secondLine.style.width = ((100 / 10) * nVal) + "%";
                $('.calc-price-span[data-calc="1"]').text(amount);
                $(`.slider-dot[data-calc="2"]`).removeClass('active');
                for (let i = 1; i < curVal; i++) {
                    let step = 0;
                    $(`.dot-${i}[data-calc="2"]`).addClass('active');
                }
            }
        });
        //Range sliders
        let first2Line = document.querySelector('#first2WidthSlider');
        document.querySelector('#first2Width').addEventListener('input', function () {
            let nVal = parseInt(this.value);
            let curVal = nVal + 2;
            first2Line.style.transform = `translateX(-${100 - ((100 / 6) * nVal)}%)`;
            amount += nVal;
            $('.calc-price-span[data-calc="2"]').text(amount);
            $(`.slider-dot[data-calc="3"]`).removeClass('active');
            for (let i = 1; i < curVal; i++) {
                let step = 0;
                $(`.dot-${i}[data-calc="3"]`).addClass('active');
            }
        });

        let second2Line = document.querySelector('#second2WidthSlider');
        document.querySelector('#second2Width').addEventListener('input', function () {
            let nVal = parseInt(this.value);
            let curVal = nVal + 2;
            second2Line.style.transform = `translateX(-${100 - ((100 / 6) * nVal)}%)`;
            amount += nVal;
            $('.calc-price-span[data-calc="2"]').text(amount);
            $(`.slider-dot[data-calc="4"]`).removeClass('active');
            for (let i = 1; i < curVal; i++) {
                let step = 0;
                $(`.dot-${i}[data-calc="4"]`).addClass('active');
            }
        });
        //Range sliders
        let first3Line = document.querySelector('#first3WidthSlider');
        document.querySelector('#first3Width').addEventListener('input', function () {
            let nVal = parseInt(this.value);
            let curVal = nVal + 2;
            first3Line.style.transform = `translateX(-${100 - ((100 / 5) * nVal)}%)`;
            amount += nVal;
            $('.calc-price-span[data-calc="3"]').text(amount);
            $(`.slider-dot[data-calc="5"]`).removeClass('active');
            for (let i = 1; i < curVal; i++) {
                let step = 0;
                $(`.dot-${i}[data-calc="5"]`).addClass('active');
            }
        });

        let second3Line = document.querySelector('#second3WidthSlider');
        document.querySelector('#second3Width').addEventListener('input', function () {
            let nVal = parseInt(this.value);
            let curVal = nVal + 2;
            second3Line.style.transform = `translateX(-${100 - ((100 / 5) * nVal)}%)`;
            amount += nVal;
            $('.calc-price-span[data-calc="3"]').text(amount);
            $(`.slider-dot[data-calc="6"]`).removeClass('active');
            for (let i = 1; i < curVal; i++) {
                let step = 0;
                $(`.dot-${i}[data-calc="6"]`).addClass('active');
            }
        });
    } catch (err) { }

    // nav range
    $('.calc-nav-item').click(function () {
        $(this).addClass("active");
        $(".calc-nav-item").not(this).removeClass("active");
        i = $(this).attr("data-calc");
        $('.item-settings-wrapper[data-calc="' + i + '"]').addClass('show');
        $('.item-settings-wrapper').not($('.item-settings-wrapper[data-calc="' + i + '"]')).removeClass('show');
        $('.calc-video[data-anim="' + i + '"]').addClass('active');
        $('.calc-video').not($('.calc-video[data-anim="' + i + '"]')).removeClass('active');
    });
});
